import React, { Component } from "react";
import {
  Table, Form, Popup, Icon, Grid, Button,
  Segment, Dimmer, Loader, Checkbox, Modal,
  Header
} from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import { PDFDownloadLink } from "@react-pdf/renderer";
import SuggestedActionsReport from "./ts-expert/SuggestedActionsReport";
import Strings from "./utilities/StringSelector";
import Constants from "./utilities/Constants";
import Utils from "./utilities/Utils";

const ipRegex = new RegExp("^[0-2][0-9.]*$");

const UtilsInstance = new Utils();

class MediaCounters extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      nowMillis: Date.now(),
      formInput: "",
      column: null,
      sortDirection: null,
      originalDevices: [],
      devices: [],
      suggestedActionsReport: "",
      isGenerateSuggestedActionsReportDimmerActive: false,
      isErrorDevicesToggleChecked: false,
      isIntelligentFilterToggleChecked: false,
      isFirstFilterRetrieve: true,
      isModalOpen: false,
      turnText: Strings.TURN_ON
    };
  }

  // Creates a list with entries that match the IP passed on the form
  handleIPSearch = () => {
    const len = this.state.originalDevices.length;
    const searchedDevices = [];

    for (let i = 0; i < len; i++) {
      if (this.state.originalDevices[i].ip === this.state.formInput) {
        searchedDevices.push(this.state.originalDevices[i]);
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }

  /*
    Filters the page list showing only the devices that match the
    ip or name the user has typed
  */
  handleSubmit = () => {
    if (this.state.formInput !== "" && ipRegex.test(this.state.formInput)) {
      this.handleIPSearch();
    }
    else if (this.state.formInput === "") {
      this.setState({ devices: this.state.originalDevices });
    }
  }

  retrieveData = async () => {
    // Only retrieve data if the form is empty and the errors toggle is not checked
    if (this.state.formInput === "" && !this.state.isErrorDevicesToggleChecked) {

      // Only get the filter state when this variable is true
      if (this.state.isFirstFilterRetrieve) {
        let promissesArray = [];

        // Retrieve devices list
        promissesArray.push(
          fetch(Constants.REQUEST_IP_ADDRESS + "mediaCounters", { mode: "cors" })
            .then(res => res.json())
            .then(data => data)
        );

        // Retrieve the intelligent filter state
        promissesArray.push(
          fetch(Constants.REQUEST_IP_ADDRESS + "filterPortsState", { mode: "cors" })
            .then(res => res.json())
            .then(data => data)
        );

        let resolvedPromisses = await Promise.all(promissesArray);

        let devices = resolvedPromisses[0].sort((a, b) => {
          const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          return num1 - num2;
        });

        let portStateFilter = resolvedPromisses[1];

        this.setState({
          devices: devices,
          originalDevices: devices,
          isIntelligentFilterToggleChecked: portStateFilter.filter,
          isFirstFilterRetrieve: false
        });

      }
      else {
        // Retrieve devices list
        fetch(Constants.REQUEST_IP_ADDRESS + "mediaCounters", { mode: "cors" })
          .then(res => res.json())
          .then((data) => {
            // Sort the devices by IP
            let devicesCopy = data.sort((a, b) => {
              const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
              const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
              return num1 - num2;
            });
            this.setState({
              devices: devicesCopy,
              originalDevices: devicesCopy
            });
          });
      }
    }
  }

  /*
    Adjusts the size of the table so that it does not excced the
    browser window height limit
  */
  adjustTableMaxHeight = () => {
    const browserHeight = UtilsInstance.getBrowserWindowHeight();
    let newTableMaxHeight = browserHeight * Constants.SCALING_FACTOR_MEDIA_COUNTERS;
    newTableMaxHeight = newTableMaxHeight.toString();
    newTableMaxHeight = newTableMaxHeight.concat("px");
    document.getElementById("main-table-container").style["maxHeight"] = newTableMaxHeight;
  }

  /*
    Saves the form input to the component state everytime the user
    types something in the form
  */
  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  getCounterCell = (value, delta) => {
    if (parseInt(delta) > 0) {
      return (
        <Table.Cell
          verticalAlign="middle"
          style={errorTableCellStyle}>
          {value}
        </Table.Cell>
      );
    }
    else {
      return (
        <Table.Cell
          verticalAlign="middle">
          {value}
        </Table.Cell>
      );
    }
  }

  generateSuggestedActionsReport = async () => {
    this.setState({ suggestedActionsReport: "" }, () => {
      this.setGeneratingSuggestedActionsDimmerState(true);
      this.setState({ suggestedActionsReport: <SuggestedActionsReport /> });
    });
  }

  setGeneratingSuggestedActionsDimmerState = (isActive) => {
    if (!isActive) {
      this.setState({ isGenerateSuggestedActionsReportDimmerActive: isActive }, () => {
        alert(Strings.GENERATING_ACTIONS_SUGGESTIONS_SUCCESS);
      });
    }
    else {
      this.setState({ isGenerateSuggestedActionsReportDimmerActive: isActive });
    }
  }

  /*  
    ------------------------------------------------------------
    ------------------------- Filtros --------------------------
    ------------------------------------------------------------  
  */

  showModal = () => this.setState({ isModalOpen: true })

  closeModal = () => this.setState({ isModalOpen: false })

  handleModalCancelClick = () => {
    this.closeModal();
  }

  handleModalOkClick = () => {
    this.alterPortsFilter();
  }

  // Returns true if the device has any input or exit errors or false otherwise
  hasDeviceAnyErrors = (device) => {
    let hasErrors = false;

    for (let i = 0; i < device.instances.length; i++) {
      if ((device.instances[i].alignment_errors !== "" && parseInt(device.instances[i].alignment_errors) > 0)
        || (device.instances[i].carrier_sense_errors !== "" && parseInt(device.instances[i].carrier_sense_errors) > 0)
        || (device.instances[i].deferred_transmission !== "" && parseInt(device.instances[i].deferred_transmission) > 0)
        || (device.instances[i].excessive_collisions !== "" && parseInt(device.instances[i].excessive_collisions) > 0)
        || (device.instances[i].fcs_errors !== "" && parseInt(device.instances[i].fcs_errors) > 0)
        || (device.instances[i].frame_too_long !== "" && parseInt(device.instances[i].frame_too_long) > 0)
        || (device.instances[i].late_collisions !== "" && parseInt(device.instances[i].late_collisions) > 0)
        || (device.instances[i].mac_receive_errors !== "" && parseInt(device.instances[i].mac_receive_errors) > 0)
        || (device.instances[i].mac_transmit_errors !== "" && parseInt(device.instances[i].mac_transmit_errors) > 0)
        || (device.instances[i].multiple_collisions !== "" && parseInt(device.instances[i].multiple_collisions) > 0)
        || (device.instances[i].single_collisions !== "" && parseInt(device.instances[i].single_collisions) > 0)
      ) {
        hasErrors = true;
        break;
      }
    }
    return hasErrors;
  }

  /*
    Decides whether or not to filter the list based on devices that have
    at least one input or one exit error at any of their ports
  */
  toggleErrorDevicesCheckbox = () => {
    // If the toggle is not checked there is something written on the form
    if (this.state.isErrorDevicesToggleChecked === false && this.state.formInput !== "") {
      // Clear the form before toggling the checkbox
      document.getElementById("inputform").value = "";
      this.setState({ formInput: "" }, () => {
        this.setState({ devices: this.state.originalDevices });
      });
    }
    // Now toggle the checkbox
    const toggled = !this.state.isErrorDevicesToggleChecked;
    this.setState({ isErrorDevicesToggleChecked: toggled }, () => {
      const infoLen = this.state.originalDevices.length;
      const searchedDevices = [];

      if (this.state.isErrorDevicesToggleChecked) {
        // Show only Devices that have at least one input or one exit error on any port
        for (let i = 0; i < infoLen; i++) {
          if (this.hasDeviceAnyErrors(this.state.originalDevices[i])) {
            searchedDevices.push(this.state.originalDevices[i]);
          }
        }
        if (searchedDevices.length > 0) {
          this.setState({ devices: searchedDevices });
        } else {
          this.setState({ devices: [] });
        }
      } else {
        // Show all Devices
        this.setState({ devices: this.state.originalDevices });
      }
    });
  }

  toggleIntelligentFilterCheckbox = () => {
    if (this.state.isIntelligentFilterToggleChecked) {
      this.setState({
        turnText: Strings.TURN_OFF,
        isModalOpen: true
      });
    }
    else {
      this.setState({
        turnText: Strings.TURN_ON,
        isModalOpen: true
      });
    }
  }

  alterPortsFilter = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "filterPorts_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: JSON.stringify({ filter: !this.state.isIntelligentFilterToggleChecked })
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        this.setState({
          isIntelligentFilterToggleChecked: !this.state.isIntelligentFilterToggleChecked,
          isFirstFilterRetrieve: true, // let the filter be refreshed once more
        }, () => {
          // refresh the data right after turning the filter on/off
          this.retrieveData();
        });
      })
      .catch((error) => {
        if (this.state.isIntelligentFilterToggleChecked) {
          alert(Strings.PORTS_FILTER_TURN_ON_FAILURE + "\n" + Strings.REASON_DP + error);
        }
        else {
          alert(Strings.PORTS_FILTER_TURN_OFF_FAILURE + "\n" + Strings.REASON_DP + error);
        }
      })
      .finally(() => {
        this.closeModal();
      });
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount = () => {
    sessionStorage.removeItem("auth");
    this.retrieveData();
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: setInterval(this.retrieveData, 5000) });
    this.adjustTableMaxHeight();
  }

  componentWillUnmount = () => {
    clearInterval(this.state.intervalID);
  }

  componentDidUpdate = () => {
    this.adjustTableMaxHeight();
  }

  render() {
    const filter = this.state.formInput;

    const mediaCounters = this.state.devices.map(device => {
      // Only show devices that support this attribute
      if (device.media_counters_attr_supported === Constants.ATTR_SUP_TRUE) {
        return (
          <React.Fragment key={device.id}>
            <Table.Row style={mainTableRowStyle}>
              <Table.Cell width={2} verticalAlign="middle">{device.ip}</Table.Cell>
              <Table.Cell colSpan="11" />
            </Table.Row>
            {
              device.instances.map(instance => (
                // eslint-disable-next-line react/jsx-key
                <Table.Row>
                  <Table.Cell verticalAlign="middle"> {instance.interface_label} </Table.Cell>
                  {this.getCounterCell(instance.alignment_errors, instance.alignment_errors_delta)}
                  {this.getCounterCell(instance.carrier_sense_errors, instance.carrier_sense_errors_delta)}
                  {this.getCounterCell(instance.fcs_errors, instance.fcs_errors_delta)}
                  {this.getCounterCell(instance.single_collisions, instance.single_collisions_delta)}
                  {this.getCounterCell(instance.multiple_collisions, instance.multiple_collisions_delta)}
                  {this.getCounterCell(instance.late_collisions, instance.late_collisions_delta)}
                  {this.getCounterCell(instance.excessive_collisions, instance.excessive_collisions_delta)}
                  {this.getCounterCell(instance.deferred_transmission, instance.deferred_transmission_delta)}
                  {this.getCounterCell(instance.frame_too_long, instance.frame_too_long_delta)}
                  {this.getCounterCell(instance.mac_transmit_errors, instance.mac_transmit_errors_delta)}
                  {this.getCounterCell(instance.mac_receive_errors, instance.mac_receive_errors_delta)}
                </Table.Row>
              ))
            }
          </React.Fragment>
        );
      }
      else if (device.media_counters_attr_supported === Constants.ATTR_SUP_FALSE) {
        return (
          <Table.Row style={mainTableRowStyle} key={device.id}>
            <Table.Cell width={2} verticalAlign="middle">{device.ip}</Table.Cell>
            <Table.Cell colSpan="11">
              {Strings.MEDIA_COUNTERS_NOT_SUPPORTED}
            </Table.Cell>
          </Table.Row>
        );
      }
      else {
        return (
          <Table.Row style={mainTableRowStyle} key={device.id}>
            <Table.Cell width={2} verticalAlign="middle">{device.ip}</Table.Cell>
            <Table.Cell colSpan="11">
              {Strings.MEDIA_COUNTERS_NOT_ANSWERED_YET}
            </Table.Cell>
          </Table.Row>
        );
      }
    });

    return (
      <div style={screenStyle}>
        <Grid columns="equal" textAlign="center" verticalAlign="middle">
          <Grid.Row style={gridRowStyle}>
            <Grid.Column>

              <Segment id="legend-segment" basic textAlign="center">

                <Button
                  content={Strings.SUGGESTED_ACTIONS_BUTTON}
                  color="teal"
                  onClick={this.generateSuggestedActionsReport} />
                <br />
                <PDFDownloadLink
                  document={this.state.suggestedActionsReport}
                  fileName={Strings.SUGGESTED_ACTIONS_FILENAME}>
                  {({ loading }) => {
                    if (loading) {
                      return Strings.FINISHING;
                    }
                    else {
                      if (this.state.isGenerateSuggestedActionsReportDimmerActive) {
                        this.setGeneratingSuggestedActionsDimmerState(false);
                      }
                      return Strings.SAVE_SUGGESTED_ACTIONS;
                    }
                  }}
                </PDFDownloadLink>

              </Segment>
            </Grid.Column>

            <Grid.Column>
              <Form style={searchStyle} onSubmit={this.handleSubmit} >
                <Form.Input
                  id="inputform"
                  placeholder={Strings.MEDIA_COUNTERS_PLACEHOLDER}
                  icon="search"
                  name="formInput"
                  value={filter}
                  onChange={this.handleChange} />
              </Form>
            </Grid.Column>

            <Grid.Column>
              <Form>
                <Form.Group grouped>
                  <Form.Field>
                    <Checkbox
                      style={checkboxStyle}
                      fitted
                      toggle
                      label={
                        <label>
                          {Strings.PORTS_FILTER_LABEL}
                          <Popup
                            wide
                            position='bottom right'
                            trigger={<Icon name="question circle" color="teal" style={questionIconStyle} />}>
                            <Popup.Content>
                              <p>{Strings.PORTS_FILTER_POPUP_1}</p>
                              <p>{Strings.PORTS_FILTER_POPUP_2}</p>
                            </Popup.Content>
                          </Popup>
                        </label>
                      }
                      onChange={this.toggleIntelligentFilterCheckbox}
                      checked={this.state.isIntelligentFilterToggleChecked} />
                  </Form.Field>
                  <Form.Field>
                    <Checkbox
                      style={checkboxStyle}
                      fitted
                      toggle
                      label={Strings.SHOW_ONLY_ERROR_DEVICES}
                      onChange={this.toggleErrorDevicesCheckbox}
                      checked={this.state.isErrorDevicesToggleChecked} />
                  </Form.Field>
                </Form.Group>
              </Form>
            </Grid.Column>

          </Grid.Row>
        </Grid>

        <Table id="table-header" style={headerMarginStyle} compact stackable fixed structured celled textAlign="center">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width={2} rowSpan="2">{Strings.IP}</Table.HeaderCell>
              <Table.HeaderCell colSpan="11">{Strings.PORTS}</Table.HeaderCell>
            </Table.Row>
            <Table.Row>

              <Popup position='bottom center' hoverable pinned wide
                trigger={
                  <Table.HeaderCell>
                    {Strings.ALIGNMENT_ERRORS_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} />
                    <br />
                    {Strings.ALIGNMENT_ERRORS_2}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.ALIGNMENT_ERRORS_POPUP}</p>
                </Popup.Content>
              </Popup>

              <Popup position='bottom center' hoverable pinned wide
                trigger={
                  <Table.HeaderCell>
                    {Strings.CARRIER_SENSE_ERRORS_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} />
                    <br />
                    {Strings.CARRIER_SENSE_ERRORS_2}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.CARRIER_SENSE_ERRORS_POPUP}</p>
                </Popup.Content>
              </Popup>

              <Popup position='bottom center' hoverable pinned wide
                trigger={
                  <Table.HeaderCell>
                    {Strings.FCS_ERRORS_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} />
                    <br />
                    {Strings.FCS_ERRORS_2}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.FCS_ERRORS_POPUP_1}</p>
                  <p>{Strings.FCS_ERRORS_POPUP_2}</p>
                </Popup.Content>
              </Popup>

              <Popup position='bottom center' hoverable pinned wide
                trigger={
                  <Table.HeaderCell>
                    {Strings.SINGLE_COLLISIONS_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} />
                    <br />
                    {Strings.SINGLE_COLLISIONS_2}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.SINGLE_COLLISION_POPUP}</p>
                </Popup.Content>
              </Popup>

              <Popup position='bottom center' hoverable pinned wide
                trigger={
                  <Table.HeaderCell>
                    {Strings.MULTIPLE_COLLISIONS_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} />
                    <br />
                    {Strings.MULTIPLE_COLLISIONS_2}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.MULTIPLE_COLLISIONS_POPUP}</p>
                </Popup.Content>
              </Popup>

              <Popup position='bottom center' hoverable pinned wide
                trigger={
                  <Table.HeaderCell>
                    {Strings.LATE_COLLISIONS_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} />
                    <br />
                    {Strings.LATE_COLLISIONS_2}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.LATE_COLLISION_POPUP_1}</p>
                  <p>{Strings.LATE_COLLISION_POPUP_2}</p>
                  <p>{Strings.LATE_COLLISION_POPUP_3}</p>
                </Popup.Content>
              </Popup>

              <Popup position='bottom center' hoverable pinned wide
                trigger={
                  <Table.HeaderCell>
                    {Strings.EXCESSIVE_COLLISIONS_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} />
                    <br />
                    {Strings.EXCESSIVE_COLLISIONS_2}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.EXCESSIVE_COLLISIONS_POPUP_1}</p>
                  <p>{Strings.EXCESSIVE_COLLISIONS_POPUP_2}</p>
                </Popup.Content>
              </Popup>

              <Popup position='bottom center' hoverable pinned wide
                trigger={
                  <Table.HeaderCell>
                    {Strings.DEFERRED_TRANSMISSION_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} />
                    <br />
                    {Strings.DEFERRED_TRANSMISSION_2}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.DEFERRED_TRANSMISSION_POPUP_1}</p>
                  <p>{Strings.DEFERRED_TRANSMISSION_POPUP_2}</p>
                </Popup.Content>
              </Popup>

              <Popup position='bottom center' hoverable pinned wide
                trigger={
                  <Table.HeaderCell>
                    {Strings.FRAME_TOO_LONG_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} />
                    <br />
                    {Strings.FRAME_TOO_LONG_2}
                    <br />
                    {Strings.FRAME_TOO_LONG_3}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.FRAME_TOO_LONG_POPUP}</p>
                </Popup.Content>
              </Popup>


              <Popup position='bottom center' hoverable pinned wide
                trigger={
                  <Table.HeaderCell>
                    {Strings.MAC_TRANSMIT_ERRORS_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} />
                    <br />
                    {Strings.MAC_TRANSMIT_ERRORS_2}
                    <br />
                    {Strings.MAC_TRANSMIT_ERRORS_3}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.MAC_TRANSMIT_ERRORS_POPUP}</p>
                </Popup.Content>
              </Popup>

              <Popup position='bottom right' hoverable pinned wide
                trigger={
                  <Table.HeaderCell>
                    {Strings.MAC_RECEIVE_ERRORS_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} />
                    <br />
                    {Strings.MAC_RECEIVE_ERRORS_2}
                    <br />
                    {Strings.MAC_RECEIVE_ERRORS_3}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.MAC_RECEIVE_ERRORS_POPUP}</p>
                </Popup.Content>
              </Popup>


            </Table.Row>
          </Table.Header>
        </Table>

        <div id="main-table-container" style={tableStyle}>
          <Table id="main-table" style={tableBorderStyle} compact stackable fixed structured celled textAlign="center">
            <Table.Body>
              {mediaCounters}
            </Table.Body>
          </Table>
        </div>

        <Dimmer page active={this.state.isGenerateSuggestedActionsReportDimmerActive} >
          <Loader size="big">{Strings.GENERATING_ACTIONS_SUGESTIONS_WAITING}</Loader>
        </Dimmer>

        <Modal style={modalStyle} centered open={this.state.isModalOpen} onClose={this.closeModal} size='small'>
          <Header icon='warning sign' content={Strings.ARE_YOU_SURE_YOU_WANT + this.state.turnText + Strings.THE_PORTS_FILTER} />
          <Modal.Content>
            <p>{Strings.PORTS_FILTER_POPUP_1}</p>
            <p>{Strings.PORTS_FILTER_POPUP_2}</p>
          </Modal.Content>
          <Modal.Actions>
            <Button color='red' onClick={this.handleModalCancelClick}>
              <Icon name='remove' />{Strings.NO}
            </Button>
            <Button color='green' onClick={this.handleModalOkClick}>
              <Icon name='checkmark' />{Strings.YES}
            </Button>
          </Modal.Actions>
        </Modal>

      </div>
    );
  }
}

// CSS custom table stylization
const screenStyle = {
  margin: "2vh 2vw",
  textAlign: "center",
};

const tableStyle = {
  overflowY: "scroll",
};

const tableBorderStyle = {
  borderCollapse: "separate"
};

const headerMarginStyle = {
  marginTop: "16px",
  marginBottom: "8px",
  width: "99%",
  borderCollapse: "separate"
};

const searchStyle = {
  margin: "0 auto",
  marginTop: "8px",
  marginBottom: "16px"
};

const mainTableRowStyle = {
  backgroundColor: "#BDBDBD"
};

const errorTableCellStyle = {
  backgroundColor: "#ff6600"
};

const questionIconStyle = {
  marginLeft: "4px"
};

const checkboxStyle = {
  marginTop: "0px"
};

const modalStyle = {
  marginLeft: "auto",
  marginRight: "auto",
  marginTop: "30vh",
  height: "275px"
};

const gridRowStyle = {
  paddingBottom: "0px"
};

export default withRouter(MediaCounters);
